import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { FiBox, FiUsers, FiBarChart2 } from 'react-icons/fi';
import './home.css';

const Home = () => {
    const { authorizedName } = useAuth();
    
    const actions = [
        {
            title: 'Upload Election Returns',
            description: 'Begin the process of uploading the election results.',
            link: '/electionform',
            icon: <FiBox className="w-8 h-8 text-blue-600" />,
            color: 'blue'
        },
        {
            title: 'View Candidates',
            description: 'See the list of all candidates running in the election.',
            link: '/candidates',
            icon: <FiUsers className="w-8 h-8 text-green-600" />,
            color: 'green'
        },
        {
            title: 'View Results',
            description: 'Check the current election results and standings.',
            link: '/electionresults',
            icon: <FiBarChart2 className="w-8 h-8 text-purple-600" />,
            color: 'purple'
        }
    ];

    return (
        <div className="bg-slate-50 min-h-screen">
            <div className="home-container has-pattern">
                <header className="home-header">
                    <h1 className="home-title">Welcome, {authorizedName}</h1>
                    <p className="home-subtitle">This is your main dashboard to manage and view election information.</p>
                </header>

                <div className="actions-grid">
                    {actions.map((action) => (
                        <Link to={action.link} key={action.title} className="action-card">
                            <div className={`action-icon bg-${action.color}-100`}>
                                {action.icon}
                            </div>
                            <h2 className="action-title">{action.title}</h2>
                            <p className="action-description">{action.description}</p>
                            <div className={`action-link text-${action.color}-600`}>
                                Proceed
                                <span>&rarr;</span>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Home;